<template>
  <div class="manual">
    <van-nav-bar
      title="关于我们"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <div class="container">
      <p>我们</p>
      <div>
        杭州巨浪物联网科技有限公司
      </div>
      <p>联系电话</p>
      <div>
        17888888888
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant'

export default {
  components: {
    'van-nav-bar': NavBar
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 0 16px;
  p {
    margin-top: 30px;
    font-size: 17px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }
  div {
    font-size: 14px;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-top: 12px;
  }
}
</style>
